export default __webpack_public_path__ + "media/src/assets/images/DOT_hazmat_class_1.1-e130e3bbbf60121d59e93c14342382a6.svg";